<script>
  import { Check } from '../lib/icons/index.js';

  // The green twin of <ErrorBanner>. Two things it fixes over the inline divs
  // it replaces: the confirmation is announced (several of these appear right
  // before an automatic redirect, so a screen-reader user would otherwise be
  // moved to another page without ever hearing that the invoice was created),
  // and the sentence is set in the body font — monospace is for codes and
  // amounts, not for prose.
  export let message = '';
  /** Hide the check icon when the caller already draws one. */
  export let icon = true;
</script>

{#if message}
  <div role="status" aria-live="polite" class="alert alert-success mb-4">
    {#if icon}
      <Check size={16} class="alert-mark mt-0.5" aria-hidden="true" />
    {/if}
    <p class="alert-message min-w-0 flex-1">{message}</p>
  </div>
{/if}
